import type { FunctionComponent } from 'react'
import { useState } from 'react'
import { useTranslation } from '../../contexts/localization/Localization'
import { openExternalEmailLink } from '../../utils/openExternalLink'

interface AiDisclaimerProps {
  allowReporting?: boolean
}

const reportEmail = 'reportai@linkando.com'

/**
 * Message indicating that the AI generated text may contain mistakes,
 * with an option to report inappropriate content.
 * @story User Story 10368: AI widgets: add disclaimer and report functionality
 */
const AiDisclaimer: FunctionComponent<AiDisclaimerProps> = ({ allowReporting = false }) => {
  const { text: t } = useTranslation()

  // State
  const [isReportSectionOpened, setIsReportSectionOpened] = useState(false)

  return (
    <div className="text-[12px]">
      {/* Disclaimer message and the report button */}
      <p className="m-0 text-[#00000066] dark:text-[#FFFFFF80]">
        {/* Disclaimer message */}
        {t('aiDisclaimer_mayContainMistakes')}

        {/* Report button */}
        {allowReporting && !isReportSectionOpened && (
          <>
            {' '}
            <a
              href=""
              className="text-inherit decoration-dashed"
              onClick={e => {
                setIsReportSectionOpened(!isReportSectionOpened)
                e.preventDefault()
              }}
            >
              {t('aiDisclaimer_report')}
            </a>
          </>
        )}
      </p>

      {/* Section for reporting content */}
      {isReportSectionOpened && (
        <span
          className="inline-flex items-center m-0 mt-1 rounded-md py-1 px-2
          text-[#00000090] dark:text-[#FFFFFF90] bg-[#ff24481d] dark:bg-[#feb5c14a]"
        >
          {/* Hint and report email link */}
          <p className="m-0">
            {t('aiDisclaimer_reportHint')}{' '}
            <a
              href={`mailto:${reportEmail}`}
              target="_blank"
              className="text-inherit"
              onClick={() => openExternalEmailLink(reportEmail)}
            >
              {reportEmail}
            </a>
            {'.'}
          </p>

          {/* Close button */}
          <span
            className="text-base ml-1 px-1 cursor-pointer"
            title={t('aiDisclaimer_close')}
            onClick={() => setIsReportSectionOpened(false)}
          >
            &times;
          </span>
        </span>
      )}
    </div>
  )
}

export default AiDisclaimer
